import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'modal.top_up.pending.title',
        defaultMessage: 'Top up in progress',
    },
    subtitle: {
        id: 'modal.top_up.pending.subtitle',
        defaultMessage:
            "You can close this window. We're transferring <span>{amount} {currency}</span> from your wallet to your card. The funds will appear on your card shortly",
    },
    button: {
        id: 'modal.top_up.pending.button',
        defaultMessage: 'Close',
    },
})
